import { Images } from "../../Images";
import BaseAutomation from "../../model/automation/BaseAutomation";
import Page from "../framework/Page";
import View from "../framework/View";

export default class AutomationView extends View {
    /**
     * @param {string} parentId
     * @param {string} elementId
     * @param {string} headerText 
     * @param {BaseAutomation} automation
     */
    constructor(parentId, elementId, headerText, automation) {
        super(parentId, elementId);
        
        /**
         * @constant
         * @type {string}
         */
        this.headerText = headerText;

        /**
         * @constant
         * @type {BaseAutomation}
         */
        this.automation = automation;

        /**
         * @type {HTMLElement}
         */
        this.mainElement = null;

        /**
         * @type {HTMLElement}
         */
        this.activeProgressElement = null;

        /**
         * @type {HTMLElement}
         */
        this.titleElement = null;
        /**
         * @type {HTMLElement}
         */
        this.descriptionElement = null;

        /**
         * @type {boolean}
         */
        this.displayedActive = automation.active;
        /**
         * @type {number}
         */
        this.displayedPercent = -1;

        this.setInitialVisibility(true);
    }

    /**
     * @override
     */
    initializeView() {
        const parent = Page.getElement(this.parentId);
        if (!parent) {
            console.log('AutomationView.initializeView() No parent element found! parentId=' + this.parentId);
            return;
        }

        const mainStyleClass = this.automation.active ? 'automation-button-outer-active' : 'automation-button-outer-not-active';

        this.mainElement = Page.createElement('div', parent, this.elementId, mainStyleClass);

        this.activeProgressElement = Page.createElement('div', this.mainElement, null, this.getProgressElementClassName());

        const bodyElement = Page.createElement('div', this.mainElement, null, 'active-skill-button-body');

        const iconElement = Page.createElement('div', bodyElement, null, 'icon-container');

        // Title/Description container
        const titleDescriptionContainer = Page.createElement('div', bodyElement, null, null); //'active-skill-title-description-container'

        // <img src="images/miner_icon_51x48.png"/>
        const imgElement = Page.createElement('img', iconElement, null, null);
        imgElement.src = Images.pick; 

        this.titleElement = Page.createElement('div', titleDescriptionContainer, null, null); //'skill-panel-row1-title'
        this.titleElement.innerHTML = this.headerText;

        this.descriptionElement = Page.createElement('div', titleDescriptionContainer, null, 'skill-panel-row2-description');
        this.descriptionElement.innerHTML = this.getDescription();

        //////////////////////////////////////
        // Setup initial visibility
        //////////////////////////////////////

        this.setInitialVisibility(false);

        //////////////////////////////////////
        // Button Click
        //////////////////////////////////////

        const thisRef = this;
        this.mainElement.onclick = function() {
            thisRef.automation.toggleActiveFlag();
        };

        super.initializeView();
    }

    /**
     * This exists so that prestige automation can inject their own class name.
     * @returns {string}
     */
    getProgressElementClassName() {
        return 'automation-progress-panel';
    }

    /**
     * @override
     */
    updateView() {
        const visible = this.automation.isUnlocked();

        if (visible !== this.isViewVisible()) {
            this.setViewVisible(visible);
        }

        // The parent class takes care of showing and hiding stuff.
        super.updateView();
    }

    /**
     * @override
     */
    updateViewContents() {

        const active = this.automation.active;
        if (this.displayedActive !== active) {
            this.displayedActive = active;

            const mainStyleClass = active ? 'automation-button-outer-active' : 'automation-button-outer-not-active';
            this.mainElement.className = mainStyleClass;

            this.descriptionElement.innerHTML = this.getDescription();
        }

        const percent = this.automation.getActivationPercent();
        if (this.displayedPercent !== percent) {
            this.displayedPercent = percent;
            this.activeProgressElement.style.width = percent + '%';
        }
    }

    /**
     * @returns {string}
     */
    getDescription() {
        return this.automation.active ? 'Active' : 'Not Active';
    }
}